import { useMediaQuery } from "@mantine/hooks";
import { em } from "@mantine/core";

export const useIsMobile = () => useMediaQuery(`(max-width: ${em(750)})`);
